import { useState } from 'react';
import TimeField from 'react-simple-timefield';
import { ChartMetaFormField } from 'models/ui';

interface EmergencyDepartmentTimeFieldProps {
  formField: ChartMetaFormField;
}

const EmergencyDepartmentTimeField = ({ formField }: EmergencyDepartmentTimeFieldProps) => {
  const { name, value, disabled, onChange, onBlur } = formField;
  const [isFocused, setIsFocused] = useState(false);
  const timeValue = String(value ?? '').trim();
  const hasValue = timeValue.length > 0;
  const isPlaceholder = !hasValue && !isFocused;

  const handleFocus = () => setIsFocused(true);

  const handleBlur = () => {
    setIsFocused(false);
    if (onBlur) onBlur(formField);
  };

  const handleChange = (_e: React.ChangeEvent<HTMLInputElement>, validatedValue: string) => {
    if (onChange) onChange(formField, { target: { value: validatedValue } });
  };

  return (
    <div className={`time-field-container u-els-display-inline-block${isPlaceholder ? ' emergency-department__time-placeholder' : ''}`}>
      <TimeField
        id={name ? `field-input-${name}` : undefined}
        className="c-els-field__input"
        value={hasValue ? timeValue : '00:00'}
        disabled={disabled}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        style={{ width: '100%' }}
      />
    </div>
  );
};

EmergencyDepartmentTimeField.displayName = 'EmergencyDepartmentTimeField';
export default EmergencyDepartmentTimeField;
